module.exports = require("react-syntax-highlighter");